import { render, staticRenderFns } from "./common-info.vue?vue&type=template&id=0d204e30&scoped=true"
import script from "./common-info.vue?vue&type=script&lang=js"
export * from "./common-info.vue?vue&type=script&lang=js"
import style0 from "./common-info.vue?vue&type=style&index=0&id=0d204e30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d204e30",
  null
  
)

export default component.exports